import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AddBoxFirstManagerOrders } from 'services/addBox'
import { resetImage } from 'store/redux/image'
import { reset } from 'store/redux/moneyPoolBox'

export default function useAddBox() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddBoxFirstManagerOrdersPayload) => {
            return AddBoxFirstManagerOrders(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('سوابق مدیر با موفقیت به صندوق شما اضافه شد')
            dispatch(reset())
            dispatch(resetImage())
            navigate('/funds')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return {
        mutate,
    }
}
